const Json2csvParser = require('json2csv').Parser;

export function descargarCSV(columnas, data, nombreArchivo) {
  const json2csvParser = new Json2csvParser({ columnas });
  const csv = json2csvParser.parse(data);

  // console.log(csv);

  let blob = new Blob([csv], { type: 'text/csv' });
  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveBlob(blob, nombreArchivo);
  } else {
    let elem = window.document.createElement('a');
    elem.href = window.URL.createObjectURL(blob);
    elem.download = nombreArchivo;
    document.body.appendChild(elem);
    elem.click();
    document.body.removeChild(elem);
  }
}
